import {site} from "../context/context";
import {ConsentMode} from "./consent-mode";
import {log} from "../util/log";

class ConsentModeManager {
    /* STATIC */

    /* INSTANCE */
    public notify(enabled: boolean): void {
        const config = site.consentModeConfig();
        if (config && config.e && config.m) {
            log.debug(`Notificando ConsentMode: ${enabled}`);
            ConsentMode.create(enabled).configure(config.m);
        }
    }
}

let instance: ConsentModeManager|null = null;
export default () => instance ??= new ConsentModeManager();
